import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';

export const studentLessonLandscapeImageFragment = gql`
  fragment StudentLessonLandscapeImageFragment on Lesson {
    landscapeImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;

export const studentLessonSquareImageFragment = gql`
  fragment StudentLessonSquareImageFragment on Lesson {
    squareImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;
